/* Clog Studios reseller storefront — behaviour for cs-* sections. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => {
    const fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  };

  /* ---- swipe strips with dots (cards + gallery) ---- */
  function bindDots(track, dots, onChange) {
    if (!track) return;
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
        if (onChange) onChange(i);
      });
    }, { passive: true });
  }
  function initCards(root = document) {
    $$('[data-cs-card]', root).forEach((card) => {
      if (card.dataset.csReady) return;
      card.dataset.csReady = '1';
      bindDots($('[data-cs-track]', card), $$('.cs-card__dot', card));
    });
  }

  /* ---- drawers + modals ---- */
  let lastFocus = null;
  function openLayer(el, trigger) {
    if (!el) return;
    lastFocus = trigger || document.activeElement;
    el.setAttribute('open', '');
    el.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    const f = $('button, a, input, select', el);
    if (f) setTimeout(() => f.focus(), 50);
  }
  function closeLayer(el) {
    if (!el) return;
    el.removeAttribute('open');
    el.setAttribute('aria-hidden', 'true');
    $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cs-open], [data-cs-open-modal]');
    if (open) {
      e.preventDefault();
      openLayer(document.getElementById(open.dataset.csOpen || open.dataset.csOpenModal), open);
      return;
    }
    const close = e.target.closest('[data-cs-close]');
    if (close) closeLayer(close.closest('[data-cs-drawer], [data-cs-modal]'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-cs-drawer][open], [data-cs-modal][open]').forEach(closeLayer);
    const f = $('[data-cs-filters].is-open');
    if (f) f.classList.remove('is-open');
  });

  /* ---- countdown to a real end date (renders only before it) ---- */
  $$('[data-cs-timer]').forEach((t) => {
    const end = Number(t.dataset.csTimer) * 1000;
    const u = (k) => $(`[data-u="${k}"]`, t);
    const tick = () => {
      let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (s === 0) { t.remove(); return; }
      const d = Math.floor(s / 86400); s %= 86400;
      const h = Math.floor(s / 3600); s %= 3600;
      const m = Math.floor(s / 60); s %= 60;
      [['d', d], ['h', h], ['m', m], ['s', s]].forEach(([k, v]) => { u(k).textContent = String(v).padStart(2, '0'); });
      setTimeout(tick, 1000);
    };
    tick();
  });

  /* ---- product page ---- */
  function initPdp(root) {
    const data = JSON.parse($('[data-cs-product]', root).textContent);
    const form = $('form[data-type="add-to-cart-form"]', root);
    const vid = $('[data-cs-vid]', root);
    const extra = $('[data-cs-extra]', root);
    const atc = $('[data-cs-atc]', root);
    const atcText = $('[data-cs-atc-text]', root);
    const fieldsets = $$('[data-cs-opt]', root);
    const track = $('[data-cs-gtrack]', root);
    const slides = track ? $$('.cs-gal__slide', track) : [];
    const thumbs = $$('[data-cs-thumb]', root);
    const bundleBox = $('[data-cs-bundles]', root);

    const findVariant = (opts) => data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
    const selected = () => fieldsets.map((fs) => ($('input:checked', fs) || {}).value);

    function goTo(i) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function setThumb(i) {
      thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
      const on = thumbs[i];
      if (on) on.parentElement.scrollTo({ top: on.offsetTop - 60, behavior: 'smooth' });
    }
    bindDots(track, $$('.cs-gal__dots .cs-card__dot', root), setThumb);
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.csThumb))));
    const cur = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const prev = $('[data-cs-gprev]', root), next = $('[data-cs-gnext]', root);
    if (prev) prev.addEventListener('click', () => goTo(Math.max(0, cur() - 1)));
    if (next) next.addEventListener('click', () => goTo(Math.min(slides.length - 1, cur() + 1)));

    function markSizes(opts) {
      // grey out sizes that don't exist / aren't available in the chosen colour
      fieldsets.forEach((fs, idx) => {
        if (!$('.cs-sz', fs)) return;
        $$('input', fs).forEach((inp) => {
          const test = opts.slice(); test[idx] = inp.value;
          const v = findVariant(test);
          inp.nextElementSibling.classList.toggle('is-out', !v || !v.available);
        });
      });
    }

    function bundleQty() {
      const b = bundleBox && $('input:checked', bundleBox);
      return b ? Number(b.value) : 1;
    }

    function syncForm() {
      const v = findVariant(selected());
      const qty = bundleQty();
      extra.innerHTML = '';
      vid.disabled = false;
      if (!v) return;
      vid.value = v.id;
      if (qty > 1) {
        // every pair row in the chosen bar is its own cart line (pair #1 mirrors the main pick)
        const bar = $('.cs-bun__bar.is-on', bundleBox);
        const lines = $$('[data-cs-pair]', bar).map((row) => findVariant($$('select', row).map((sel) => sel.value)) || v);
        vid.disabled = true;
        lines.forEach((line, i) => {
          extra.insertAdjacentHTML('beforeend',
            `<input type="hidden" name="items[${i}][id]" value="${line.id}"><input type="hidden" name="items[${i}][quantity]" value="1">`);
        });
        const ok = lines.every((l) => l.available);
        atc.disabled = !ok;
        atcText.textContent = ok ? 'Add to Cart' : 'Sold out';
      }
    }

    function update(fromUser) {
      const opts = selected();
      fieldsets.forEach((fs, i) => { const s = $('[data-cs-optval]', fs); if (s) s.textContent = opts[i] || ''; });
      const v = findVariant(opts);
      markSizes(opts);
      if (!v) {
        atc.disabled = true; atcText.textContent = 'Unavailable';
        return;
      }
      $('[data-cs-now]', root).textContent = money(v.price);
      const was = $('[data-cs-was]', root), save = $('[data-cs-save]', root);
      const hasCmp = v.compare_at_price && v.compare_at_price > v.price;
      was.hidden = !hasCmp; save.hidden = !hasCmp;
      if (hasCmp) { was.textContent = money(v.compare_at_price); $('span', save).textContent = money(v.compare_at_price - v.price); }
      atc.disabled = !v.available;
      atcText.textContent = v.available ? 'Add to Cart' : 'Sold out';
      if (fromUser) {
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
        if (v.featured_media) {
          const i = slides.findIndex((s) => s.dataset.mediaId === String(v.featured_media.id));
          if (i >= 0) goTo(i);
        }
        // pair #1 always mirrors the main pick; other pairs follow until the shopper changes them
        $$('[data-cs-pair]', root).forEach((pair) => {
          if (pair.dataset.csPair !== '1' && pair.dataset.touched) return;
          $$('select', pair).forEach((sel, k) => { sel.value = opts[k]; });
        });
      }
      syncForm();
    }

    fieldsets.forEach((fs) => fs.addEventListener('change', () => update(true)));
    if (bundleBox) {
      const paint = () => $$('.cs-bun__bar', bundleBox).forEach((bar) => bar.classList.toggle('is-on', $('input', bar).checked));
      bundleBox.addEventListener('change', (e) => {
        const pair = e.target.closest('[data-cs-pair]');
        if (pair && pair.dataset.csPair === '1') {
          // pair #1 drives the main variant (price, gallery, URL)
          $$('select', pair).forEach((sel, k) => {
            const inp = fieldsets[k] && $$('input', fieldsets[k]).find((i) => i.value === sel.value);
            if (inp) inp.checked = true;
          });
          paint();
          update(true);
          return;
        }
        if (pair) pair.dataset.touched = '1';
        paint();
        syncForm();
      });
      // selects inside a <label> would otherwise toggle the radio on every click
      $$('select', bundleBox).forEach((s) => s.addEventListener('click', (e) => e.stopPropagation()));
      paint();
    }
    update(false);
    // form must not submit with an "items" set left over from a previous choice
    form.addEventListener('submit', syncForm, true);
  }
  $$('[data-cs-pdp]').forEach(initPdp);

  /* ---- collection filters ---- */
  $$('[data-cs-filters-form]').forEach((form) => {
    const panel = $('[data-cs-filters]', form);
    const submit = () => {
      // drop empty price fields so the URL stays clean
      $$('input[type="number"]', form).forEach((i) => { i.disabled = i.value === ''; });
      form.submit();
    };
    form.addEventListener('change', (e) => {
      if (e.target.matches('[data-cs-autosubmit], input[type="checkbox"]') && window.matchMedia('(min-width: 990px)').matches) submit();
      else if (e.target.matches('[data-cs-autosubmit]')) submit();
    });
    form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
    const openBtn = $('[data-cs-filters-open]', form);
    if (openBtn) openBtn.addEventListener('click', () => { panel.classList.add('is-open'); openBtn.setAttribute('aria-expanded', 'true'); });
    const closeBtn = $('[data-cs-filters-close]', form);
    if (closeBtn) closeBtn.addEventListener('click', () => { panel.classList.remove('is-open'); if (openBtn) openBtn.setAttribute('aria-expanded', 'false'); });
  });

  /* ---- "Styled by you" videos: play while visible, tap to toggle sound ---- */
  const vids = $$('video[data-cs-autoplay]');
  if (vids.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) e.target.play().catch(() => {}); else e.target.pause();
    }), { threshold: 0.25 });
    vids.forEach((v) => io.observe(v));
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cs-sound]');
    if (!b) return;
    const v = b.parentElement.querySelector('video');
    v.muted = !v.muted;
    if (!v.muted) v.play().catch(() => {});
    b.setAttribute('aria-pressed', String(!v.muted));
    b.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
  });

  $$('[data-cs-eta]').forEach((el) => {
    let left = Number(el.dataset.csEta);
    const d = new Date();
    while (left > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) left -= 1; }
    el.textContent = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  });

  /* ---- product grid carousel (pages of cards, prev/next) ---- */
  function initPg(root = document) {
    $$('[data-cs-pg]', root).forEach((pg) => {
      if (pg.dataset.csReady) return;
      pg.dataset.csReady = '1';
      const track = $('[data-cs-pg-track]', pg);
      const pages = $$('.cs-pg__page', track);
      const prev = $('[data-cs-pg-prev]', pg), next = $('[data-cs-pg-next]', pg);
      if (!prev || pages.length < 2) return;
      const cur = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      const go = (i) => track.scrollTo({ left: pages[Math.max(0, Math.min(pages.length - 1, i))].offsetLeft, behavior: 'smooth' });
      const sync = () => { const i = cur(); prev.disabled = i === 0; next.disabled = i >= pages.length - 1; };
      prev.addEventListener('click', () => go(cur() - 1));
      next.addEventListener('click', () => go(cur() + 1));
      track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
      sync();
    });
  }
  initPg();
  document.addEventListener('shopify:section:load', (e) => initPg(e.target));

  initCards();
  document.addEventListener('shopify:section:load', (e) => initCards(e.target));
})();
